import { memo } from 'react';

import { Button, Flex, Label, ListBox, ListBoxItem, Popover, Select, SelectValue, Text } from '@/components/core';
import { ChevronIcon } from '@/components/icons';
import { useTriggerStore } from '@/store';
import { toString } from '@/utils';

export type HttpMethodProps = {
  defaultHttpMethod?: 'post' | 'get' | 'put' | 'patch' | 'delete';
};

const IHttpMethod = ({ defaultHttpMethod = 'post' }: HttpMethodProps) => {
  const action = useTriggerStore((state) => state.action);
  const updateAction = useTriggerStore((state) => state.updateAction);

  return (
    <Flex col className="gap-xs">
      <Label>HTTP Method</Label>
      <Select
        defaultSelectedKey={toString(action?.config?.httpMethod)?.toLowerCase() ?? defaultHttpMethod}
        onSelectionChange={(key) =>
          updateAction({ config: { ...action.config, httpMethod: key?.toString() ?? defaultHttpMethod } })
        }
      >
        <div className="flex grow-0">
          <Button variant="secondary">
            <Text slot="description" className="grow">
              <SelectValue />
            </Text>
            <ChevronIcon rotation="down" />
          </Button>
        </div>
        <Popover>
          <ListBox>
            <ListBoxItem id="post">
              <Text>POST</Text>
            </ListBoxItem>
            <ListBoxItem id="get">
              <Text>GET</Text>
            </ListBoxItem>
            <ListBoxItem id="put">
              <Text>PUT</Text>
            </ListBoxItem>
          </ListBox>
        </Popover>
      </Select>
    </Flex>
  );
};

export const HttpMethod = memo(IHttpMethod) as typeof IHttpMethod;
